import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, Facebook, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t-2 border-black" data-id="element-81">
      <div className="container mx-auto px-0" data-id="element-82">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4" data-id="element-83">
          {/* Brand Column */}
          <div className="p-8 border-b-2 md:border-b-0 lg:border-r-2 border-black" data-id="element-84">
            <Link to="/" className="block mb-6" data-id="element-85">
              <span className="font-heading font-black text-2xl tracking-tighter uppercase" data-id="element-86">
                Pixel<span className="text-swiss-red" data-id="element-87">Perfect</span>
              </span>
            </Link>
            <p className="text-black font-medium leading-relaxed mb-8" data-id="element-88">
              Bold design for bold brands. We create digital experiences that
              demand attention.
            </p>
            <div className="flex gap-4" data-id="element-89">
              {[Instagram, Twitter, Linkedin, Facebook].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 border-2 border-black flex items-center justify-center text-black hover:bg-black hover:text-white transition-all shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px]" data-id="element-90">
                  <Icon size={18} data-id="element-91" />
                </a>)}
            </div>
          </div>

          {/* Links Column */}
          <div className="p-8 border-b-2 md:border-b-0 lg:border-r-2 border-black" data-id="element-92">
            <h4 className="font-black text-black uppercase mb-6 tracking-wider" data-id="element-93">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-94">
              {['About Us', 'Our Team', 'Careers', 'Contact'].map(item => <li key={item} data-id="element-95">
                  <Link to={`/${item.toLowerCase().replace(' ', '-')}`} className="text-black font-medium hover:text-swiss-red hover:underline decoration-2 underline-offset-4 transition-colors" data-id="element-96">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services Column */}
          <div className="p-8 border-b-2 md:border-b-0 lg:border-r-2 border-black" data-id="element-97">
            <h4 className="font-black text-black uppercase mb-6 tracking-wider" data-id="element-98">
              Services
            </h4>
            <ul className="space-y-4" data-id="element-99">
              {['Brand Identity', 'UI/UX Design', 'Development', 'Marketing'].map(item => <li key={item} data-id="element-100">
                  <Link to="/services" className="text-black font-medium hover:text-swiss-red hover:underline decoration-2 underline-offset-4 transition-colors" data-id="element-101">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Newsletter Column */}
          <div className="p-8" data-id="element-102">
            <h4 className="font-black text-black uppercase mb-6 tracking-wider" data-id="element-103">
              Stay Updated
            </h4>
            <p className="text-black font-medium mb-4 text-sm" data-id="element-104">
              Join our newsletter.
            </p>
            <form className="flex flex-col gap-4" data-id="element-105">
              <input type="email" placeholder="ENTER YOUR EMAIL" className="w-full px-4 py-3 bg-white border-2 border-black text-sm font-bold placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-swiss-red focus:border-transparent uppercase" data-id="element-106" />
              <button className="w-full px-4 py-3 bg-black text-white font-bold uppercase tracking-wider hover:bg-swiss-red transition-colors flex items-center justify-center gap-2" data-id="element-107">
                Subscribe <ArrowRight size={16} data-id="element-108" />
              </button>
            </form>
          </div>
        </div>

        <div className="border-t-2 border-black p-4 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-bold uppercase tracking-widest" data-id="element-109">
          <p data-id="element-110">© 2024 PixelPerfect Agency.</p>
          <div className="flex gap-8" data-id="element-111">
            <a href="#" className="hover:text-swiss-red transition-colors" data-id="element-112">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-swiss-red transition-colors" data-id="element-113">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}